import { render, staticRenderFns } from "./ProfileTabs.vue?vue&type=template&id=7885b35e&"
import script from "./ProfileTabs.vue?vue&type=script&lang=js&"
export * from "./ProfileTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTabs.vue?vue&type=style&index=0&id=7885b35e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports